/* global ga, COMSCORE, PARSELY */

import $ from 'jquery';


export default {
    interaction(e) {
        let $element = $(e.currentTarget),
            rawTracking = $element.attr('data-tracking'),
            tracking = rawTracking.length ? JSON.parse(rawTracking) : {},
            action = this.getAction(e),
            data;

        data = $.extend({
            hitType: 'event',
            eventAction: action,
            eventLabel: $element.html(),
            page: window.location.pathname + window.location.hash
        }, tracking);

        this.track(data, e);
    },

    getAction(e) {
        let type = e.type,
            action = null;

        switch(type) {
            case 'click':
                action = 'Clicked On';
                break;
            case 'mouseover':
                action = 'Hovered Over';
                break;
            default:
                action = type.charAt(0).toUpperCase() + type.slice(1) + ' On';
                break;
        }

        return action;
    },

    track(data, event) {
        if (event) {
            let element = event.currentTarget,
                url = element.getAttribute('href'),
                external = element.getAttribute('target');

            if (external) {
                let tab = window.open();

                data.hitCallback = function() {
                    tab.location = url;
                };

                event.preventDefault();
            }
        }

        ga('send', data);
        ga('UDMedia.send', data);
    },

    comscore(url){
        COMSCORE.beacon({ c1: '2', c2: '17689855', c4: url });
    },

    parsely(data) {
        if (typeof PARSELY !== 'undefined') {
            let info = $.extend({}, {
                js: 1
            }, data);

            PARSELY.beacon.trackPageView(info);
        }
    }
};



/** WEBPACK FOOTER **
 ** ./frontend/js/utils/tracking.js
 **/